// Libraries
import { IconProps } from '@chakra-ui/react';

/**
 * Enumeration representing EyeIcon view boxes.
 */
export enum EyeIconViewBox {
  /**
   * viewBox values for opn.
   */
  OPEN = '0 0 18 12',
  /**
   * viewBox values for close.
   */
  CLOSE = '0 0 18 15',
}

/**
 * Type of Eye icon to display.
 */
export enum EyeIconType {
  /**
   * Display the eye icon opened.
   */
  OPEN = 'OPEN',
  /**
   * Display the eye icon closed.
   */
  CLOSE = 'CLOSE',
}

/**
 * Props for the EyeIcon component.
 */
export type EyeIconProps = IconProps & {
  /**
   * The eye icon status, which should be one of the keys defined in the EyeIconType enum.
   */
  iconType?: keyof typeof EyeIconType;
};

/**
 * Enumeration representing EyeIcon paths.
 */
export enum EyeIconPaths {
  /**
   * EyeIcon path to display an open eye.
   */
  OPEN = 'M17.8913 5.54376C16.1966 2.23719 12.8416 0 9 0C5.15843 0 1.80249 2.23875 0.108733 5.54407C0.0372461 5.68548 0 5.84172 0 6.00017C0 6.15862 0.0372461 6.31485 0.108733 6.45626C1.80342 9.76283 5.15843 12 9 12C12.8416 12 16.1975 9.76127 17.8913 6.45595C17.9628 6.31454 18 6.15831 18 5.99986C18 5.8414 17.9628 5.68517 17.8913 5.54376ZM9 10.5C8.10998 10.5 7.23995 10.2361 6.49993 9.74163C5.75991 9.24716 5.18313 8.54436 4.84253 7.72209C4.50194 6.89982 4.41282 5.99502 4.58646 5.1221C4.76009 4.24919 5.18868 3.44736 5.81801 2.81802C6.44735 2.18869 7.24918 1.7601 8.12209 1.58647C8.99501 1.41284 9.89981 1.50195 10.7221 1.84255C11.5443 2.18314 12.2472 2.75992 12.7416 3.49994C13.2361 4.23996 13.5 5.10999 13.5 6.00001C13.5003 6.59104 13.3841 7.17633 13.1581 7.72243C12.932 8.26853 12.6005 8.76472 12.1826 9.18264C11.7647 9.60056 11.2685 9.93202 10.7224 10.1581C10.1763 10.3841 9.59103 10.5003 9 10.5ZM9 3.00001C8.73223 3.00375 8.46618 3.04359 8.20906 3.11844C8.42101 3.40647 8.52271 3.76091 8.49574 4.11749C8.46876 4.47407 8.31489 4.80918 8.06203 5.06204C7.80917 5.3149 7.47406 5.46877 7.11748 5.49575C6.7609 5.52272 6.40646 5.42102 6.11843 5.20907C5.95442 5.81332 5.98403 6.45379 6.20308 7.04033C6.42214 7.62687 6.81961 8.12994 7.33956 8.47875C7.85951 8.82756 8.47575 9.00454 9.10155 8.98477C9.72735 8.965 10.3312 8.74948 10.8281 8.36855C11.325 7.98762 11.6899 7.46046 11.8715 6.86126C12.0531 6.26206 12.0422 5.621 11.8404 5.02831C11.6386 4.43562 11.256 3.92114 10.7465 3.55729C10.2369 3.19344 9.62611 2.99853 9 3.00001Z',
  /**
   * EyeIcon path to display an closed eye.
   */
  CLOSE = 'M8.99991 11.25C6.86664 11.25 5.13977 9.59883 4.98086 7.50633L2.03056 5.22625C1.64272 5.71281 1.28581 6.22721 0.997811 6.78971C0.933473 6.91698 0.899952 7.05759 0.899952 7.20019C0.899952 7.3428 0.933473 7.48341 0.997811 7.61068C2.52303 10.5866 5.54252 12.6 8.99991 12.6C9.75675 12.6 10.4869 12.4875 11.1906 12.3058L9.73116 11.1766C9.49014 11.2232 9.24538 11.2478 8.99991 11.25ZM17.8261 12.8841L14.7169 10.4811C15.6613 9.68514 16.4381 8.70932 17.002 7.61039C17.0664 7.48313 17.0999 7.34252 17.0999 7.19991C17.0999 7.0573 17.0664 6.9167 17.002 6.78943C15.4768 3.81353 12.4573 1.80007 8.99991 1.80007C7.5519 1.80182 6.12741 2.16636 4.85655 2.86038L1.2785 0.0948548C1.23184 0.0585476 1.17848 0.0317904 1.12148 0.0161121C1.06448 0.000433765 1.00494 -0.00385832 0.946279 0.00348108C0.887616 0.0108205 0.830974 0.0296475 0.77959 0.0588864C0.728206 0.0881252 0.683088 0.127203 0.646812 0.173886L0.0947201 0.884602C0.0214824 0.978816 -0.0113349 1.09826 0.00348583 1.21667C0.0183066 1.33508 0.0795517 1.44275 0.173751 1.51601L16.7213 14.3052C16.768 14.3416 16.8213 14.3683 16.8783 14.384C16.9353 14.3997 16.9949 14.404 17.0535 14.3966C17.1122 14.3893 17.1688 14.3705 17.2202 14.3412C17.2716 14.312 17.3167 14.2729 17.353 14.2262L17.9054 13.5155C17.9786 13.4213 18.0114 13.3018 17.9965 13.1834C17.9816 13.065 17.9203 12.9573 17.8261 12.8841ZM12.659 8.89036L11.5537 8.03592C11.6467 7.7669 11.6961 7.4847 11.6999 7.20005C11.7054 6.78331 11.6131 6.3711 11.4303 5.99651C11.2476 5.62193 10.9796 5.29542 10.6478 5.04321C10.316 4.79101 9.92967 4.62013 9.51985 4.54431C9.11003 4.46849 8.68814 4.48984 8.28807 4.60665C8.45767 4.83646 8.54941 5.11444 8.54991 5.40006C8.54572 5.4951 8.53119 5.5894 8.5066 5.68131L6.43633 4.08128C7.15547 3.48031 8.06271 3.15076 8.99991 3.15006C9.53185 3.14977 10.0586 3.25432 10.5501 3.45775C11.0416 3.66117 11.4882 3.95948 11.8643 4.33562C12.2405 4.71175 12.5388 5.15834 12.7422 5.64984C12.9456 6.14134 13.0502 6.66812 13.0499 7.20005C13.0499 7.80839 12.9011 8.37539 12.659 8.89064V8.89036Z',
}
